import { selectFeatureFlag } from "shared/reducers/sysReducer";
import {
  isCaseBayshoreDNE,
  isCasePCOnly,
  isCaseTCOnly,
} from "shared/utils/caseUtils";

import { useAppSelector } from "store/hooks";

import { useDefaultSignature } from "./useDefaultSignature";

export const useForcedModifier = () => {
  const caseDetailObject = useAppSelector(({ caseDetail }) => caseDetail);
  const forceTCPCModifiersFlag = useAppSelector((state) =>
    selectFeatureFlag(state, "forceTCPCModifiers")
  );
  const defaultSignature = useDefaultSignature();

  const forceTCOnly = forceTCPCModifiersFlag && isCaseTCOnly(caseDetailObject);
  const forcePCOnly =
    forceTCPCModifiersFlag &&
    (isCasePCOnly(caseDetailObject) ||
      isCaseBayshoreDNE(caseDetailObject, defaultSignature));
  const forcedModifier = forceTCOnly ? "TC" : forcePCOnly ? "26" : undefined;

  return { forcedModifier, forceTCOnly, forcePCOnly };
};
